import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import router from '../router'

import notification from 'ant-design-vue/es/notification'
import { VueAxios } from './axios'
import { message, Modal } from 'ant-design-vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
// const pending = []
// const removePending = config => {
//   for (const p in pending) {
//     if (pending[p].u === config.url) {
//       pending[p].f()
//       pending.splice(p, 1)
//     }
//   }
// }
// 创建 axios 实例
message.config({
  top: `300px`,
  maxCount: 1
})
const service = axios.create({
  baseURL: '/req',
  validateStatus: function(status) {
    return status >= 200 && status < 600
  }
  // timeout: 30000 // 请求超时时间
})

const err = error => {
  if (error.response) {
    const data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      notification.error({
        message: 'Forbidden',
        description: data.message
      })
    } else if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      notification.error({
        message: 'Unauthorized',
        description: 'Authorization verification failed'
      })
      if (token) {
        window.location.reload()
        // store.dispatch('Logout').then(() => {
        //   setTimeout(() => {
        //     window.location.reload()
        //   }, 1500)
        // })
      }
    } else if (error.response.status === 503) {
      console.log(router)
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  // removePending(config)

  // config.cancelToken = new axios.CancelToken(c => {
  //   pending.push({
  //     u: config.url,
  //     f: c
  //   })
  // })
  const token = Vue.ls.get(ACCESS_TOKEN)

  if (
    config.url.indexOf('/distribution/cartItem/showPrice') === -1 &&
    config.url.indexOf('/distribution/pay/payStatus/') === -1 &&
    config.url.indexOf('/distribution/groupLevel/getFbaUnitDiscount') === -1
  ) {
    store.commit('SET_LOADING', true)
    store.commit('SET_LOADINGCOUNT', 1)
  }
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  const cookie = Vue.ls.get('sCookie')
  if (cookie && config.url === '/api/auth/register') {
    config.headers['s-cookie'] = cookie // 注册判断来源
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use(response => {
  if (
    response.config.url.indexOf('/distribution/cartItem/showPrice') === -1 &&
    response.config.url.indexOf('/distribution/pay/payStatus/') === -1 &&
    response.config.url.indexOf('/distribution/groupLevel/getFbaUnitDiscount') === -1
  ) {
    store.commit('SET_LOADINGCOUNT', -1)
  }
  if (store.state.app.loadingCount === 0) {
    store.commit('SET_LOADING', false)
  }

  if (response.status === 200) {
    if (response.data.status_code === 200) {
      if (response.config.method === 'post' || response.config.method === 'put') {
        if (response.data.msg && response.data.msg.replace(' ', '')) {
          message.success(response.data.msg, response.data.time ? response.data.time : 2)
        }
      }
      return response.data
    } else if (response.data.status_code === 501) {
      Modal.confirm({
        title: '温馨提示',
        content: '您已超出当前设计数量，请购买设计数量服务！',
        okText: '立即购买',
        okType: 'danger',
        cancelText: '关闭',
        onOk() {
          window.open('/setting/valueAddedServicesDesign')
        }
      })
      return Promise.reject(response.data)
    } else {
      if (response.data.msg) {
        const msgArr = response.data.msg.split('<br>').filter(item => {
          return item
        })
        message.error(
          h => {
            return msgArr.map(item => {
              return (
                <span style="text-align: left">
                  <span>{item}</span>
                  <br />
                </span>
              )
            })
          },
          response.data.time ? response.data.time : 2
        )
      }

      return Promise.reject(response.data)
    }
  } else if (response.status === 401) {
    router.push({
      // 传递参数使用query的话，指定path或者name都行，但使用params的话，只能使用name指定
      path: '/user/login',
      query: {
        auth: '0'
      }
    })
  } else {
    message.error('Network Error', 1)
    return Promise.reject(response)
  }
}, err)

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export { installer as VueAxios, service as axios }
